import Results from '@pelckmans/elementis/components/results';
import { getResultPercentages, Status } from '../../../../utils/results';
import { SCORE_STATUS } from '../../../../constants/ScoreStatus';

export interface ScorableProgressProps {
  unachievable?: boolean;
  score?: {
    maximum: number;
    achievable: number;
    achieved: number;
    status?: Status;
  };
  variant?: 'donut' | 'bar';
  responsive?: boolean;
}

export default function ScorableProgress({
  unachievable = false,
  score,
  variant = 'bar',
  responsive = true,
}: ScorableProgressProps) {
  const status = score?.status ? score.status : 'not-started';

  if (unachievable || score?.achieved === -1) {
    return <Results quantifiable={false} status={status} showTooltip variant={variant} />;
  }

  return (
    <Results
      quantifiable
      status={status}
      showTooltip
      responsive={responsive}
      {...getResultPercentages(score, status === SCORE_STATUS.PENDING_GRADING)}
      variant={variant}
    />
  );
}
